<template>
    <div ref="root">
        <app-modulebackground
            :module-id="module.id"
            custom-class="awards__background module__background"
        ></app-modulebackground>
        <div
            class="textbox__container module__container"
            v-bind:class="{
                container__boxed: [1, 2, 3, 4, 5, 6].includes(module.layout.type)
            }"
        >
            <div class="textbox__inner module__inner">
                <div class="textbox__inner--main module__inner--main">
                    <div
                        class="textbox__cols"
                        v-if="items && Array.isArray(items) && items.length > 0"
                    >
                        <div
                            class="textbox__col"
                            v-for="(textbox__value, textbox__key) in items"
                            v-bind:key="textbox__key"
                        >
                            <div
                                class="textbox__inner-row module__inner-row"
                                v-if="
                                    textbox__value.data &&
                                        (textbox__value.data.title || textbox__value.data.subtitle)
                                "
                            >
                                <div class="textbox__inner-col module__inner-col">
                                    <div class="textbox__header module__header">
                                        <h2
                                            class="textbox__title module__title font-h2 color-h2"
                                            v-if="textbox__value.data.title"
                                            v-html="textbox__value.data.title"
                                        ></h2>
                                        <h3
                                            class="textbox__subtitle module__subtitle font-h3 color-h3"
                                            v-if="textbox__value.data.subtitle"
                                            v-html="textbox__value.data.subtitle"
                                        ></h3>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="textbox__inner-row module__inner-row"
                                v-if="
                                    textbox__value.data &&
                                        textbox__value.data.image &&
                                        textbox__value.data.image.id
                                "
                            >
                                <div class="textbox__inner-col module__inner-col">
                                    <app-moduleimage
                                        :data="textbox__value.data.image"
                                        :width="700"
                                        :tag="'img'"
                                        :img-opacity="false"
                                        :custom-class="'textbox__moduleimage module__moduleimage'"
                                    ></app-moduleimage>
                                </div>
                            </div>
                            <div
                                class="textbox__inner-row module__inner-row"
                                v-if="textbox__value.data && textbox__value.data.text"
                            >
                                <div class="textbox__inner-col module__inner-col">
                                    <div
                                        class="textbox__text module__text font-p color-p module__cms"
                                        v-if="textbox__value.data.text"
                                        v-html="textbox__value.data.text"
                                    ></div>
                                </div>
                            </div>
                            <div
                                class="textbox__inner-row module__inner-row"
                                v-if="
                                    (textbox__value.data.link && textbox__value.data.link.active) ||
                                        (textbox__value.data.link2 &&
                                            textbox__value.data.link2.active) ||
                                        (textbox__value.data.link3 &&
                                            textbox__value.data.link3.active)
                                "
                            >
                                <div class="textbox__inner-col module__inner-col">
                                    <div class="textbox__cta module__cta">
                                        <app-modulebutton
                                            :data="textbox__value.data.link"
                                            :custom-class="
                                                'textbox__cta-btn module__cta-btn font-button color-button bg-color-button'
                                            "
                                        ></app-modulebutton>
                                        <app-modulebutton
                                            :data="textbox__value.data.link2"
                                            :custom-class="
                                                'textbox__cta-btn module__cta-btn font-button color-button bg-color-button'
                                            "
                                        ></app-modulebutton>
                                        <app-modulebutton
                                            :data="textbox__value.data.link3"
                                            :custom-class="
                                                'textbox__cta-btn module__cta-btn font-button color-button bg-color-button'
                                            "
                                        ></app-modulebutton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { toArray } from '@/helpers/utils';
import ModuleImage from '@/components/assorted/ModuleImage';
import ModuleButton from '@/components/assorted/ModuleButton';
import ModuleBackground from '@/components/assorted/ModuleBackground';

export default {
    data() {
        return {};
    },
    components: {
        'app-moduleimage': ModuleImage,
        'app-modulebutton': ModuleButton,
        'app-modulebackground': ModuleBackground
    },
    methods: {},
    computed: {
        items() {
            return toArray(this.module.data.texts)
                .filter((i) => i.visible)
                .sort((a, b) => a.pos - b.pos);
        }
    },
    props: {
        module: Object
    },
    mounted() {}
};
</script>
